export type PlannedFeatureGroup = {
  title: string;
  items: readonly string[];
};

/** Planowane rozszerzenia aplikacji — wspólna lista dla Przewodnika, landingu i modułów. */
export const PLANNED_FEATURE_GROUPS: readonly PlannedFeatureGroup[] = [
  {
    title: "IRZ i zgłoszenia urzędowe",
    items: [
      "Automatyczna rejestracja jagniąt w IRZplus",
      "Automatyczne zgłaszanie przemieszczeń zwierząt",
      "Zgłaszanie padnięć zwierząt",
      "Generowanie zgłoszeń do PIW",
    ],
  },
  {
    title: "Kontrole i raporty",
    items: [
      "Ważenie matek podczas kontroli stada",
      "Rejestracja szczepień i odrobaczania w terenie",
      "Raporty PDF z ważeń, szczepień i odrobaczeń",
    ],
  },
  {
    title: "Stado i gatunki",
    items: [
      "Obsługa bydła i kóz — osobne grupy zwierząt",
      "Rozbudowane grupowanie stad (np. pastwiska, sezony, linie hodowlane)",
    ],
  },
  {
    title: "Statystyki",
    items: [
      "Statystyki przyrostów jagniąt i wykotów — wagi, tempo wzrostu, porównania między sezonami",
    ],
  },
] as const;

/** Rejestracja jagniąt w IRZ z poziomu wykotów — wyłączone do czasu wdrożenia. */
export const LAMB_IRZ_REGISTRATION_ENABLED = false;

export const LAMB_IRZ_DISABLED_TOOLTIP =
  "Ta funkcjonalność jeszcze nie została udostępniona.";
